<template>
  <div
    :class="{ 'pb-10': !isActive }"
    class="relative"
  >
    <div
      ref="step-border"
      v-if="!isLast"
      class="absolute h-full ml-4 border-l-2 border-sc-blue"
    />
    <div class="relative flex items-center bg-white">
      <div
        ref="step-number"
        class="w-8 h-8 text-lg text-center border-2 rounded-full border-sc-blue"
        :class="isActive ? 'bg-sc-blue text-white' : 'bg-white text-sc-blue'"
      >
        {{ step }}
      </div>
      <span
        ref="step-title"
        class="ml-2 text-xl text-sc-blue"
      >
        {{ title }}
      </span>
    </div>
    <div
      ref="step-content"
      v-if="isActive"
      class="mx-10"
    >
      <div
        v-if="content.lines"
        class="py-2 md:py-8 text-base md:text-lg text-primary"
      >
        <div
          v-for="(line, index) in content.lines"
          :key="index"
        >
          <a
            v-if="line.href"
            :ref="`line-${index + 1}-href`"
            target="_blank"
            class="text-base md:text-lg text-link hover:text-link hover:underline"
            :href="line.href"
          >
            {{ line.message }}
          </a>
          <p
            v-else
            :ref="`line-${index + 1}-text`"
            class="text-base md:text-lg text-primary"
          >
            {{ line.message }}
          </p>
          <button
            v-if="line.action"
            :ref="`line-${index + 1}-button`"
            class="px-3 py-1 ml-1 text-sm leading-5 text-center text-white rounded bg-sc-blue hover:text-white"
            @click="$emit(line.action.emit, line.action.value)"
          >
            {{ line.action.button }}
          </button>
        </div>
      </div>
      <div
        v-if="content.input"
        class="mt-3 md:w-88"
      >
        <b-field
          class="border-none appearance-none focus:outline-none"
        >
          <b-input
            type="text"
            :placeholder="content.input.placeholder"
            aria-label="mail"
            v-model="inputValue"
            size="is-small"
            ref="step-input"
          />
        </b-field>
        <button
          class="block w-full px-3 py-1 text-sm leading-5 text-center text-white rounded bg-sc-blue hover:text-white"
          @click="$emit(content.input.emit, inputValue)"
          ref="step-input-button"
        >
          {{ content.input.button }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      inputValue: '',
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: Object,
      default: null,
    },
    step: {
      type: Number,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
};

</script>
